/**
 * The running tab's own build (WEB-APP-VERSION-REFRESH-001).
 *
 * Every web build stamps its id and its time into each HTML entry (`<meta name="app-build-id">`,
 * `<meta name="app-build-time">` — shared-config's `puffin:build-identity` plugin). The build a tab runs is the one
 * its document was served with — the very thing a reload replaces — so the build freshness monitor compares its id
 * with the deployed `version.json`, and the footers show its code and date (owner ruling "Code and date").
 *
 * @module @puffin-core/api-client/buildIdentity
 */

import { BUILD_IDENTITY } from '@puffin-core/client-contract';

/**
 * @param {Document|undefined} doc
 * @param {string} name - a meta tag's `name`
 * @returns {string|null} its `content`, or `null` when absent or empty
 */
function metaContent(doc, name) {
  const meta = doc.querySelector(`meta[name="${name}"]`);
  const content = meta ? meta.getAttribute('content') : null;
  return content || null;
}

/**
 * @param {Document|undefined} [doc=globalThis.document] - the document to read (injectable for tests)
 * @returns {{id: string, builtAt: (string|null)}|null} the stamped build, or `null` when the document carries no id
 *   (a dev server, a test page, or no document at all)
 */
export function readDocumentBuild(doc = globalThis.document) {
  if (!doc) return null;
  const id = metaContent(doc, BUILD_IDENTITY.META_NAME);
  if (!id) return null;
  return { id, builtAt: metaContent(doc, BUILD_IDENTITY.TIME_META_NAME) };
}
